module.exports = __webpack_public_path__ + "static/media/OWL_Logos_FInal-02.e0bf2c90.png";